import React from "react";
import styles from "./CustomColorField.module.css";
import classnames from "classnames";

interface ColorFieldProps {
    disabled?: boolean;
    isRequired: boolean;
    title: string;
    value?: string;
    setValue: (value: string) => void;
    errorMessage?: string;
}

export const CustomColorField: React.FC<ColorFieldProps> = ({
    disabled,
    isRequired,
    title,
    value = '#000000',
    setValue,
    errorMessage
}) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.titleWrapper}>
                <span className={classnames(styles.title, disabled && styles.disabledTitle)}>{title}</span>
                {(isRequired && !disabled) && <span className={styles.asterisk}>*</span>}
            </div>
            <div className={styles.colorInputWrapper}>
                <input
                    type="text"
                    value={value}
                    disabled={disabled}
                    onChange={e => setValue(e.target.value)}
                    className={errorMessage ? styles.inputWithError : styles.input}
                    placeholder="#000000"
                />
                <div 
                    className={styles.colorPreview} 
                    style={{ backgroundColor: value}}
                >
                    <input
                        type="color"
                        value={value}
                        disabled={disabled}
                        onChange={e => setValue(e.target.value)}
                        className={styles.hiddenColorInput}
                    />
                </div>
            </div>
            <div style={{visibility: `${!errorMessage ? "hidden" : "visible"}`}} className={styles.errorWrapper}>
                <img src={"/alertIcon.svg"} alt={"alert icon"}/>
                <span className={styles.errorMessage}>{errorMessage}</span>
            </div>
        </div>
    );
}; 
